module.exports = __webpack_public_path__ + "static/media/github.87da8261.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/github.svg
// module id = 468
// module chunks = 0